export default __webpack_public_path__ + "static/media/confetti.3a78db48.svg";